export default __webpack_public_path__ + "static/poster-3cff580a29e831f3068deb177e446011.png";